import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  Renderer2,
} from '@angular/core';

/**
 * @see https://github.com/angular/angular/issues/21782
 */
@Directive({ selector: 'input' })
export class InputAccessorDirective {
  private currentValue: string | null = null;

  constructor(
    private element: ElementRef,
    private renderer: Renderer2,
  ) {}

  @Input()
  set value(value: string) {
    if (value !== this.currentValue) {
      this.renderer.setProperty(this.element.nativeElement, 'value', value);
    }
  }

  @HostListener('input', ['$event.target'])
  onInput(target: HTMLInputElement) {
    this.currentValue = target.value;
  }
}
